import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';

import { Frat } from './routes/Frat';
import { Login } from './routes/Login';
import { Signup } from './routes/Signup';
import { Home } from './routes/Home';
import { CreateReview } from './routes/CreateReview';
import { ProtectedRoute } from './components/ProtectedRoute';
import { Compare } from './routes/Compare';
import { Profile } from './routes/Profile';
import { NotFound } from './routes/NotFound';
import { AddFrat } from './routes/AddFrat';

/*const Login  = () => (
  <div>Login</div>
)
*/

function App() {
  return (
    <BrowserRouter>
      <div>
        <Routes>
          <Route exact path="/" element={<Home />} />
          <Route path="frat" element={<Frat />} />
          <Route path="frat/:fratname" element={<Frat />} />
          <Route path="login" element={<Login />} />
          <Route path="signup" element={<Signup />} />
          <Route path="createReview" element={<ProtectedRoute state={{ next: '/createReview' }} />}>
            <Route index element={<CreateReview />} />
          </Route>
          <Route path="editReview" element={<ProtectedRoute state={{ next: '/editReview' }} />}>
            <Route index element={<CreateReview />} />
          </Route>
          <Route path='compare' element={<Compare />} />
          <Route path='profile' element={<Profile />} />
          {/* <Route path="addFrat" element={<AddFrat />} /> */}
          <Route path='*' element={<NotFound />} />
        </Routes>
      </div>
    </BrowserRouter>
  );
}

export default App;
